/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".address-entry[_ngcontent-%COMP%]{max-height:60vh;overflow:auto;padding:1rem .25rem}"];
export { styles as styles };
